import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger";
import Draggable from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger, Draggable); 

const orizontalContainer = document.querySelector(".horizontal-scroll");
if (orizontalContainer) {
    const animate = orizontalContainer.querySelector(".flex");
    
    // Applica trasformazione per utilizzare l'accelerazione hardware
    gsap.set(animate, {
        willChange: "transform",
        force3D: true
    });
    
    // Draggable con parametri ottimizzati per movimento fluido
    Draggable.create(animate, {
        type: "x",
        edgeResistance: 0.85,
        bounds: {
            minX: -(animate.offsetWidth - window.innerWidth),
            maxX: 0
        },
        inertia: true,
        throwResistance: 1000, // Ridotto per maggiore scorrevolezza
        overshootTolerance: 0.8, // Permette un leggero superamento dei limiti
        dragClickables: true,
        dragResistance: 0.2, // Minore resistenza per movimento più fluido
        ease: "power2.out" // Curva di easing per movimento più naturale
    });
}